import { useEffect, useState } from 'react';

/** Підписка на медіазапит — щоб інтерфейс на телефоні відрізнявся не лише стилями. */
export function useMedia(query: string): boolean {
  const [matches, setMatches] = useState(() => matchMedia(query).matches);
  useEffect(() => {
    const mq = matchMedia(query);
    const on = (): void => setMatches(mq.matches);
    mq.addEventListener('change', on);
    on();
    return () => mq.removeEventListener('change', on);
  }, [query]);
  return matches;
}

export const usePhone = (): boolean => useMedia('(max-width: 860px)');
